import { render } from "./OverlayComponent.vue?vue&type=template&id=29b27b5b"
import script from "./OverlayComponent.vue?vue&type=script&lang=js"
export * from "./OverlayComponent.vue?vue&type=script&lang=js"

import "./OverlayComponent.vue?vue&type=style&index=0&id=29b27b5b&lang=css"

import exportComponent from "/Users/mac/MyDev/3-READY/v2t/vid2text/youtest.ru/youtest-front-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__